export default __webpack_public_path__ + "static/The-Enterprise-path-to-service-mesh-Architectures-2nd-Edition-eea4ddbfdb979daf9295e71101c489fc.webp";